import React from 'react'

// import  { StyledRow, CalendlyWrapper } from './CalendlyBooking.styles';
import './calendly.css'

const iframeStyle = {
  backgroundColor: "#2a2a2a",
};

const CalendlyBooking = props =>  {

    return (
      <div style={{ backgroundColor: "#1a202c", width: "100%" }}>
        {/* <StyledRow> */}
        <div className="row">
            <div className="calendly-wrapper">
                 <iframe
                 title="PL Booking"
              src={props.url}
              width="100%"
              height="100%"
              frameBorder="0"
              style={iframeStyle}
            />
            </div>
        </div>
         
        {/* </StyledRow> */}
      </div>
    );
}

export default CalendlyBooking;
